module.exports = __webpack_public_path__ + "static/media/hana_table.b513644f.png";